const {h, render, Component} = require('preact');
const {route} = require('preact-router')
const queryString = require('qs')

const Articles = require('./all_articles')
const FAQSearchContainer = require('../search/faq_search')
const SupportAPIHelper = require('../../../../../support/frontend/helpers/API')
const BreadCrumbsHelper = require('../../views/common/breadcrumbs/helper')
const WidgetsContainer = require('../main/widgets')
const SpinnerView = require('../../views/common/spinner')
const ErrorView = require('../main/error')

class TrendingTopics extends Component {
  constructor(props) {
    super(props);
    this.handleTopicSelection = this.handleTopicSelection.bind(this);
  }

  setTopicsResponse(result) {
    if (result) {
      let length = result.groupTopics.length
      let left = result.groupTopics.splice(0, length/2)
      let right = result.groupTopics
      this.setState({
        'data': {'topics': result.FAQTopics, 'trendingArticles': {'left': left, 'right': right}},
        'isLoading': false
      })
    }
  }

  componentWillMount() {
    let trendingTopicsUrl = `${Groupon.Utils.getConfigFromDom().FAQBASEURL}/group_topics?page=faq`;
    let errorCb = (response) => {
      this.setState({'data': null, 'isLoading': false, 'isFailure': true})
    }
    let successCb = (response) => {
      if (response) {
        this.setTopicsResponse(response)
      }
    }
    this.setState({'data': null, 'isLoading': true})
    SupportAPIHelper.get(trendingTopicsUrl, null, successCb, errorCb, false);
  }

  handleTopicSelection(type, index){
    route(`/faq#faqs:${type}-${index}?crumbs=${BreadCrumbsHelper.encodeBreadCrumb(this.props.crumbs)}`)
  }

  getArticlesPageParams() {
    let id = this.props.id, pageParams
    if (this.props.type == 'categories')
      pageParams = {'categoryId': id}
    if (this.props.type == 'content')
      pageParams = {'contentId': id}
    return pageParams
  }

  render() {
    if(this.state.isLoading)
      return (<SpinnerView/>)
    if (this.state.isFailure)
      return (<ErrorView/>)
    if(!this.props.id && this.state.data)
    {
    return (
      <div>
        <div style="margin-left: 28px">
          <FAQSearchContainer/>
        </div>
        <article id="trending-topics-content" class="tab-contents">
          <section id="trending-topic-section" class="tab-content active">
            <aside class="topics-side-nav">
              <ul id="trending-topics-secondary-nav" class="unstyled trending-topics-nav">
                  {this.state.data.topics.map((item,i) =>
                  <li onClick={(e) => {
                  e.preventDefault()
                  this.handleTopicSelection('category',item.categoryId)}} key={item.categoryId}> <a href="#" data-bhw={"web2018_faq_trending_topic_category_"+item.categoryId}>{item.title}</a> </li>)}
              </ul>
            </aside>
            <div class="trending-topics-article-contents">
              <div class='title'>{I18n.t('js.modules.web_2018.most_popular_questions')}</div>
              <div  class='left-content'>
                  {
                    this.state.data.trendingArticles.left.map((items,i) =>
                    <ul class='unstyled'>
                      <li class='topic_heading'>{items.title}</li>
                      {items.topics.map((item,i) =>
                      <li onClick={(e) => {
                        e.preventDefault()
                        this.handleTopicSelection('content',item.id)}} key={item.id}> <a href="#" data-bhw={"web2018_faq_trending_topic_article_"+item.id}>{item.title}</a> </li>
                      )}
                    </ul>
                    )
                  }
              </div>
              <div class='right-content'>
                  {
                    this.state.data.trendingArticles.right.map((items,i) =>
                    <ul class='unstyled'>
                      <li class='topic_heading'>{items.title}</li>
                      {items.topics.map((item,i) =>
                      <li onClick={(e) => {
                        e.preventDefault()
                        this.handleTopicSelection('content',item.id)}} key={item.id}> <a href="#" data-bhw={"web2018_faq_trending_topic_article_"+item.id}>{item.title}</a> </li>
                      )}
                    </ul>
                    )
                  }
              </div>
            </div>
          </section>
        </article>
        <WidgetsContainer isFaq="true"/>
      </div>
    )
  }
  return (<Articles pageParams={this.getArticlesPageParams()} fromFaq={true}/>)
  }
}

module.exports = TrendingTopics
